import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-block pt-2" }
const _hoisted_2 = { class: "form-label fw-bolder" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "d-block pt-2" }
const _hoisted_5 = { class: "form-label fw-bolder" }
const _hoisted_6 = { class: "d-block pt-2" }
const _hoisted_7 = { class: "form-label fw-bolder" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSelectFilterable = _resolveComponent("FormSelectFilterable")!
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_FormTextAreaClearable = _resolveComponent("FormTextAreaClearable")!
  const _component_CatalogOptions = _resolveComponent("CatalogOptions")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: _ctx.show,
    title: _ctx.t('CopyCatalog'),
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:show'))),
    closeOnOuterClick: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('CopyCatalogTo')), 1),
          _createVNode(_component_FormSelectFilterable, {
            modelValue: _ctx.copyTo,
            items: _ctx.copyToOptions,
            "onUpdate:modelValue": _ctx.onCopyToUpdate
          }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
        ]),
        (_ctx.copyTo == _ctx.newCatalogValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('CatalogCode')), 1),
                _createVNode(_component_FormInputClearable, {
                  modelValue: _ctx.code,
                  validators: _ctx.validators.code,
                  "onUpdate:modelValue": _ctx.onCodeUpdate
                }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
              ]),
              _createElementVNode("label", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('CatalogDescription')), 1),
                _createVNode(_component_FormTextAreaClearable, {
                  modelValue: _ctx.description,
                  rows: 3,
                  validators: _ctx.validators.description,
                  "onUpdate:modelValue": _ctx.onDescriptionUpdate
                }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
              ]),
              _createVNode(_component_CatalogOptions, {
                t: _ctx.t,
                "instance-id": _ctx.instanceId,
                onOnTypeUpdated: _ctx.onTypeUpdated
              }, null, 8, ["t", "instance-id", "onOnTypeUpdated"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Btn, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Btn, {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onSave()), ["prevent"])),
            disabled: !_ctx.isFormValid,
            primary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Save', true)), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}